export const styles: { [key: string]: React.CSSProperties } = {
  formWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '80px',
    maxWidth: '500px',
    width: '100%',
    boxSizing: 'border-box',
  },
  addPageButton: {
    padding: '15px 0',
    textTransform: 'none',
    width: '170px',
  },
  button: {
    color: '#655C68',
    borderColor: '#E3DDE6',
    textTransform: 'none',
    padding: '10px 16px',
    fontSize: '14px',
    borderRadius: '5px',
  },
  buttonSelected: {
    fontWeight: 700,
    color: '#3293DB',
    borderColor: '#3293DB',
    backgroundColor: '#F2F9FF',
    textTransform: 'none',
  },
  booleanWrapper: { display: 'flex', flexDirection: 'column', gap: '32px' },
  paginationButtons: { display: 'flex', justifyContent: 'center', gap: '24px' },
};
